export const STORIES_PROTRACK_FILTER_DEFAULT_ID = 'all'
export const STORIES_PROTRACK_FILTER_DEFAULT_VALUE = 'All ProTracks'
